export class ApiStore {
  api;

  store;

  constructor(store) {
    this.store = store;
  }

  setApi(api) {
    this.api = api;
  }
}
